import * as Scrivito from "scrivito";
import defaultSocialHeaderButtonAttributes from "../_defaultSocialHeaderButtonAttributes";

const ViadeoSocialHeaderButton = Scrivito.provideObjClass(
  "ViadeoSocialHeaderButton",
  defaultSocialHeaderButtonAttributes,
);

export default ViadeoSocialHeaderButton;
